import axios from 'axios'
import { createResource } from '../utils/resource'

const baseStore = createResource('paddle', {})

const paddleStore = {
  ...baseStore,
  actions: {
    ...baseStore.actions,
    async getProducts() {
      try {
        const result = await axios.get('/api/paddle/products')
        return { data: result.data as any[], error: null }
      } catch (e) {
        return { data: null, error: e }
      }
    },
    async getProductById({}, {id}: {id: string}) {
      try {
        const result = await axios.get('/api/paddle/products/' + id)
        return { data: result.data as any, error: null }
      } catch (e) {
        return { data: null, error: e }
      }
    },
  },
}

export default paddleStore
